import { Component, OnInit } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'np-drop-zone-remove-badge',
  template: `
    <svg>
      <line x1="0" y1="0" x2="10" y2="10" />
      <line x1="0" y1="10" x2="10" y2="0" />
    </svg>
  `,
  styleUrls: ['./drop-zone-remove-badge.component.scss']
})
export class DropZoneRemoveBadgeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
